import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/arrow-right-up.svg'


const _withScopeId = n => (_pushScopeId("data-v-5677f311"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "end w-full" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Claim ")
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" View ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "open",
  class: "ml"
}, null, -1 /* HOISTED */))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nomad_button = _resolveComponent("nomad-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" <nomad-button\n      v-if=\"expired\"\n      primary\n      class=\"action\"\n      @disabled=\"disabled\"\n      @click=\"cancel\"\n    >\n      Cancel\n    </nomad-button> "),
    (_ctx.ready)
      ? (_openBlock(), _createBlock(_component_nomad_button, {
          key: 0,
          primary: "",
          class: "action",
          onDisabled: _ctx.disabled,
          onClick: _ctx.claim
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onDisabled", "onClick"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("a", {
      class: "flex flex-row items-center justify-center cursor-pointer",
      href: _ctx.explorerLink,
      target: "_blank"
    }, _hoisted_6, 8 /* PROPS */, _hoisted_3)
  ]))
}